import { render, staticRenderFns } from "./AssignMember.vue?vue&type=template&id=ea8bd462"
import script from "./AssignMember.vue?vue&type=script&lang=js"
export * from "./AssignMember.vue?vue&type=script&lang=js"
import style0 from "./AssignMember.vue?vue&type=style&index=0&id=ea8bd462&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports